import { render, staticRenderFns } from "./newsDetail.vue?vue&type=template&id=021e23ff&scoped=true&"
import script from "./newsDetail.vue?vue&type=script&lang=js&"
export * from "./newsDetail.vue?vue&type=script&lang=js&"
import style0 from "./newsDetail.vue?vue&type=style&index=0&id=021e23ff&lang=scss&scoped=true&"
import style1 from "./newsDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021e23ff",
  null
  
)

export default component.exports